'use client';
import { FC, useState } from 'react';

import Button from '@gds/Button/Button';

import styles from './PlpIntro.module.css';

interface Props {
  messages: {
    readMoreCta: string;
    readLessCta: string;
    intro: string;
  };
}

const PlpIntro: FC<Props> = ({ messages }) => {
  const [isExpanded, setExpanded] = useState(false);
  const toggleSection = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setExpanded(e => !e);
  };
  return (
    <div className={`${styles.makeModelIntro} ${isExpanded ? styles.expanded : ''}`}>
      <div className={`${styles.copy} ${isExpanded ? styles.expanded : ''}`}>{messages.intro}</div>
      <Button
        variant="link"
        onClick={toggleSection}
        className={`${styles.viewMore} ${isExpanded ? styles.expanded : ''}`}
      >
        {isExpanded ? messages.readLessCta : messages.readMoreCta}
      </Button>
    </div>
  );
};

export { PlpIntro };
